import { render, staticRenderFns } from "./SetChangePassword.vue?vue&type=template&id=20451710&"
import script from "./SetChangePassword.vue?vue&type=script&lang=js&"
export * from "./SetChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports